module.exports = __webpack_public_path__ + "static/media/Credits-13.a6358874.pdf";